import "./details.css";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";



/* 🔥 SINGLE SOURCE OF TRUTH */
function useChargerStatus(chargerId, connectorId) {
  const [status, setStatus] = useState({
    online: false,
    locked: false,
    vehicle: false,
  });

  useEffect(() => {
    let active = true;

    const fetchData = async () => {
      try {
        const res = await fetch("https://ocpp.rivotmotors.com/v1/graphql", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-hasura-admin-secret": "CitrineOS!",
          },
          body: JSON.stringify({
            query: `
              query GetLiveStatus($stationId: String!, $connectorId: Int!) {
                ChargingStations(where: { id: { _eq: $stationId } }) {
                  isOnline
                }
                Connectors(where: { stationId: { _eq: $stationId }, connectorId: { _eq: $connectorId } }) {
                  status
                }
                vehicledata(where: { stationid: { _eq: $stationId } }, limit: 1, order_by: { created_at: desc }) {
                  model
                }
              }
            `,
            variables: {
              stationId: chargerId,
              connectorId: Number(connectorId),
            },
          }),
        });

        const json = await res.json();
        if (!active) return;

        const isOnline = json.data?.ChargingStations?.[0]?.isOnline;
        const connectorStatus =
          json.data?.Connectors?.[0]?.status?.toLowerCase();
        const vehicle = json.data?.vehicledata?.[0]?.model;

        const locked =
          connectorStatus === "preparing" ||
          connectorStatus === "charging";

        const vehicleDetected = !!vehicle;

        setStatus({
          online: isOnline,
          locked,
          vehicle: vehicleDetected,
        });
      } catch (e) {
        console.error(e);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 5000); // ✅ 5 sec polling

    return () => {
      active = false;
      clearInterval(interval);
    };
  }, [chargerId, connectorId]);

  return status;
}


export default function ChargerDetails({ data, onProceed = () => {} }) {
  const { chargerId, connectorId } = useParams();

  const [step, setStep] = useState(1);
  const [checkingDone, setCheckingDone] = useState(false);
  const [isStepDone, setIsStepDone] = useState(false);

  const [status, setStatus] = useState({
    online: false,
    locked: false,
    vehicle: false,
  });

  // 🔥 MAIN LOGIC (ONLY SOURCE OF TRUTH)
  useEffect(() => {
    let interval;

    const fetchStatus = async () => {
      if (checkingDone) return;

      try {
        const res = await fetch("https://ocpp.rivotmotors.com/v1/graphql", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-hasura-admin-secret": "CitrineOS!",
          },
          body: JSON.stringify({
            query: `
            query GetLiveStatus($stationId: String!, $connectorId: Int!) {
              ChargingStations(where: { id: { _eq: $stationId } }) {
                isOnline
              }
              Connectors(where: { stationId: { _eq: $stationId }, connectorId: { _eq: $connectorId } }) {
                status
              }
              vehicledata(where: { stationid: { _eq: $stationId } }, limit: 1, order_by: { created_at: desc }) {
                model
              }
            }`,
            variables: {
              stationId: chargerId,
              connectorId: Number(connectorId),
            },
          }),
        });

        const json = await res.json();
        const isOnline = json.data?.ChargingStations?.[0]?.isOnline;
        const connectorStatus =
          json.data?.Connectors?.[0]?.status?.toLowerCase();
        const vehicle = json.data?.vehicledata?.[0]?.model;

        const locked =
          connectorStatus === "preparing" ||
          connectorStatus === "charging";

        const vehicleDetected = !!vehicle;

        setStatus({
          online: isOnline,
          locked,
          vehicle: vehicleDetected,
        });

        if (!isOnline) {
          setStep(1);
          setIsStepDone(false);
        }
        else if (isOnline && step === 1) {
          setIsStepDone(true);

       setTimeout(() => {
            setStep(2);
            setIsStepDone(false);
          }, 2000); 
        }
        else if (!locked) {
          setStep(2);
          setIsStepDone(false);
        }

        else if (locked && step === 2) {
          setIsStepDone(true);

          setTimeout(() => {
            setStep(3);
            setIsStepDone(false);
          }, 800);
        }

        else if (!vehicleDetected) {
          setStep(3);
          setIsStepDone(false);
        }

        else {
          setIsStepDone(true);

          setTimeout(() => {
            setCheckingDone(true);
          }, 800);
        }

      } catch (e) {
        console.error(e);
      }
    };

    fetchStatus();
    interval = setInterval(fetchStatus, 3000);

    return () => clearInterval(interval);
  }, [step, checkingDone]);

  const handleProceed = () => {
    if (typeof onProceed === "function") {
      onProceed(data.status?.toLowerCase() || "available");
    }
  };

  return (
    <div className="pref-containersss">

      {/* 🔥 OVERLAY */}
        {!checkingDone && (
        <div className="overlay">
          <div className="overlayContent">

            {/* 🚨 OFFLINE STATE */}
            {!status.online && step === 1 ? (
              <>
                <div className="errorCircle">!</div>
                <h2 className="overlayTitle">Charger Offline</h2>
                <p className="overlaySub">
                  Please try again after some time
                </p>
              </>
            ) : (
              <>
                {/* ✅ TITLE */}
                <h2 className="overlayTitle">
                  {step === 1 && "Checking Charger"}
                  {step === 2 && "Checking Connector"}
                  {step === 3 && "Detecting Vehicle"}
                </h2>

                {/* ✅ STEP CONTENT */}
                {step === 2 && !status.locked ? (
                  <>
                    <div className="loaderBig"></div>
                    <p className="overlaySub">
                      Please connect the connector to the vehicle
                    </p>
                  </>
                ) : !isStepDone ? (
                  <div className="loaderBig"></div>
                ) : (
                  <div className="successWrapper">
                  <svg className="tickSvg" viewBox="0 0 52 52">
                    <circle className="tickCircle" cx="26" cy="26" r="25" fill="none" />
                    <path
                      className="tickPath"
                      fill="none"
                      d="M14 27 L22 35 L38 18"
                    />
                  </svg>
                </div>
                )}
              </>
            )}

          </div>
        </div>
      )}

      {/* 🔥 YOUR ORIGINAL UI (UNCHANGED) */}
      <div>
        <div className="screen">

          <header className="topbarssss">
            <h2 className="title">Charger Details</h2>
          </header>

          <main className="main">

            <div className="heroCard">
              <div
                className="heroImage"
                style={{ backgroundImage: "url(/flsahcharger.png)" }}
              >
                <div className="imageOverlay"></div>
                <div className="badge">
                  <div className="pulse"></div>
                  {data.status}
                </div>
              </div>

              <div className="stationInfo">
                <span className="nodeTag">SUPERCHARGER NODE</span>
                <h1 className="stationName">{data.stationName}</h1>
                <p className="stationId">ID: {data.chargerId}</p>
              </div>
            </div>

            <div className="specGrid">
              <div className="specCard">
                <div className="specIcon">
                  <span className="material-symbols-outlined">bolt</span>
                </div>
                <div>
                  <p className="specLabel">POWER RATING</p>
                  <p className="specValue">{data.powerRating}kW</p>
                </div>
              </div>

              <div className="specCard">
                <div className="specIcon">
                  <span className="material-symbols-outlined">ev_charger</span>
                </div>
                <div>
                  <p className="specLabel">CONNECTOR</p>
                  <p className="specValue">{data.connector}</p>
                </div>
              </div>
            </div>

            <h3 className="sectionTitle">BILLING DETAILS</h3>
            <div className="billingCard">
              <div className="billingRow">
                <div className="billingLeft">
                  <div className="billingIcon">
                    <span className="material-symbols-outlined">payments</span>
                  </div>
                  <div>
                    <p className="billingTitle">Charging Rate</p>
                    <p className="billingSub">Standard outdoor rate</p>
                  </div>
                </div>
                <div className="billingPrice">
                  ₹{data.rate}<span>/kWh</span>
                </div>
              </div>

              <div className="billingRow">
                <div className="billingLeft">
                  <div className="billingIcon">
                    <span className="material-symbols-outlined">credit_card</span>
                  </div>
                  <div>
                    <p className="billingTitle">Secure Payment</p>
                    <p className="billingSub">Safe & encrypted transaction</p>
                  </div>
                </div>
                <span className="material-symbols-outlined successIcon">
                  done_all
                </span>
              </div>
            </div>

            <div className="locationNote">
              <span className="material-symbols-outlined locationIcon">
                location_on
              </span>
              <p>{data.location}</p>
            </div>

          </main>

          <div>
            <button
              className="ctaButton"
              onClick={handleProceed}
              disabled={!checkingDone}
            >
              <span className="material-symbols-outlined">
                electric_bolt
              </span>
              Proceed to Charge
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
